export default "__VITE_ASSET__DCMRgQ1H__"